<template>
  <div class="wrapper">
    <slot />
    <div class="tooltip">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: ["text"]
}
</script>

<style lang="sass" scoped>


.wrapper
  position: relative
  .tooltip
    transition: .2s
    opacity: 0
    pointer-events: none
    white-space: nowrap
    background-color: #fff
    border: 1px solid rgba(0, 0, 0, 0.1)
    color: rgba(0, 0, 0, .5)
    padding: 3px 5px
    border-radius: 4px
    font-size: 12px
    position: absolute
    top: calc( 110% )
    left: 0
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2)
  &:hover
    .tooltip
      opacity: 1
</style>
